import React from 'react';
import {useSelector} from 'react-redux';
import NationalPendingSheet from '../../pages/login/steps/components/national-pending-sheet/NationalPendingSheet.component';
import NationalRejectedSheet from '../../pages/login/steps/components/national-rejected-sheet/NationalRejectedSheet.component';
import DebtInitialDeposit from '../../pages/profile/components/debt-initial-deposit/DebtInitialDeposit.component';
import WalletChargeSheet from '../../pages/profile/components/wallet-charge-sheet/WalletChargeSheet.component';
import AuxiliaryMobileSheet from '../../pages/profile/user-account/components/auxiliary-mobile-sheet/AuxiliaryMobileSheet.component';
import EmailSheet from '../../pages/profile/user-account/components/email-sheet/EmailSheet.component';
import {selectrootsheettype} from '../../selectors/SheetSelector';
import SupportMessageSheet from '../../pages/profile/support/components/support-message-sheet/SupportMessageSheet.component';
import BuyPackageSheet from '../../pages/profile/packages/components/buy-package-sheet/BuyPackageSheet.component';
import ConfirmReturnDeposit from '../../pages/profile/support/components/confirm-return-deposit/ConfirmReturnDeposit.component';
import EndTripErrorSheet from '../../pages/trip/components/end-trip-error-sheet/EndTripErrorSheet.component';
import {useHistory} from '../../imports/Router';
import {selecetmaptype} from '../../selectors/Map';
import ShabaSheet from '../../pages/profile/user-account/components/shaba-sheet/ShabaSheet.component';
import ParkingBottomSheet from '../../imports/Map/components/ParkingBottomSheet';
import {ConfirmStartTripSheet} from '../../pages/damage/damage-list/components/ConfirmStartTripSheet';
import {MinorProblemSheet} from '../../pages/damage/damage-list/components/MinorProblemSheet';
import ConfirmHealthSheet from 'src/pages/trip/reserve/components/confirm-health-sheet/ConfirmHealthSheet';
import PurchasePackageError from '../../components/purchase-package-error/PurchasePackageError';
import RetryCaptureImage from 'src/pages/confirm-danger-ride/components/RetryCaptureImage';
import TripMessageSheet from 'src/pages/trip/components/trip-message-sheet/TripMessageSheet';
import SliderLearn from '../../pages/profile/learn/components/motor/component/SliderLearn';
import EndImageLearn from '../../pages/profile/learn/components/endtrip-learn/EndImageLearn';
import AppLearn from '../../pages/profile/learn/components/app-learn/AppLearn';
import LockLearn from '../../pages/profile/learn/components/lock-learn/LockLearn'
export default function RootSheet() {
  const {sheetId} = useSelector(state => selectrootsheettype(state));
  const {tehran} = useSelector(state => state.map);
  const {permitionModal} = useSelector(state => state.app);
  const {locationPermition} = useSelector(state => selecetmaptype(state));
  const history = useHistory();
  if (
    (sheetId == '' || (tehran && locationPermition) || permitionModal) &&
    history.location.pathname.includes('main/map')
  )
    return;
  switch (sheetId) {
    case 'parking':
      return <ParkingBottomSheet />;
    case 'nationalCardPending':
      return <NationalPendingSheet />;
    case 'nationalCardRejected':
      return <NationalRejectedSheet />;
    case 'debtInitialDeposit':
      return <DebtInitialDeposit />;
    case 'auxiliaryMobile':
      return <AuxiliaryMobileSheet />;
    case 'email':
      return <EmailSheet />;
    case 'shaba':
      return <ShabaSheet />;
    case 'walletCharge':
      return <WalletChargeSheet />;
    case 'supportMessage':
      return <SupportMessageSheet />;
    case 'buyPackage':
      return <BuyPackageSheet />;
    case 'confirmReturnDeposit':
      return <ConfirmReturnDeposit />;
    case 'endTripError':
      return <EndTripErrorSheet />;
    case 'confirmStartTrip':
      return <ConfirmStartTripSheet />;
    case 'minorProblem':
      return <MinorProblemSheet />;
    case 'confirmHealth':
      return <ConfirmHealthSheet />;
    case 'purchasePackageError':
      return <PurchasePackageError />;
    case 'retryCaptureImage':
      return <RetryCaptureImage />;
    case 'tripMessage':
      return <TripMessageSheet />;
    case 'motorSelection':
      return <SliderLearn />;
    case 'EndTrip':
      return <EndImageLearn />;
  case 'AppLearn':
      return <AppLearn />;
       case 'LockLearn':
      return <LockLearn />;
      
    default:
      return null;
  }
}
